import { render, staticRenderFns } from "./numbers-stats-general-chart-main.vue?vue&type=template&id=95754cfa&"
import script from "./numbers-stats-general-chart-main.vue?vue&type=script&lang=js&"
export * from "./numbers-stats-general-chart-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports